import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const errText = (e, fallback = "Errore") => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x?.msg || String(x)).join("; ") || fallback;
  return typeof d === "string" && d ? d : fallback;
};

export function makeApi(getToken, onUnauthorized) {
  const instance = axios.create({ baseURL: API });
  instance.interceptors.request.use(async (config) => {
    const token = getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  instance.interceptors.response.use((r) => r, (error) => {
    if (error.response?.status === 401 && getToken() && onUnauthorized) onUnauthorized();
    return Promise.reject(error);
  });
  return instance;
}

export const LABELS = {
  percentage: "Percentuale", fixed: "Importo fisso", tiered: "A scaglioni",
  active: "Attivo", superseded: "Sostituito", pending_approval: "In approvazione", rejected: "Rifiutato",
  pending: "In attesa", approved: "Approvato", suspended: "Sospeso", paid: "Liquidata", generated: "Generato", demo: "Demo",
};
export const label = (v) => LABELS[v] || v || "—";

export function formatEUR(n) {
  if (n === null || n === undefined || isNaN(n)) return "— €";
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n);
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return new Intl.DateTimeFormat("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" }).format(d);
  } catch { return "—"; }
}
